<template>
    <div class="header-container" :style="{background: colors.header.bg}">
        <div class="header-title">
            <p class="header-title-text" :style="{color: colors.header.text}">Chat with Hearo Support</p>
            <p class="header-paticipants-text">
                <span>{{myself.name}} &amp; </span>
                <span>{{other.name}}</span>
            </p>
        </div>
        
        <div class="header-minimize" :style="[myself.isAdmin ? {marginRight: '10px'} : {}]">
              <slot name="close-button">
                <a class="header-exit-button" href="#"
                   @click.prevent="onMinimize">-</a>
            </slot>
        </div>
        <div v-if="myself.isAdmin" class="header-exit">
            <slot name="close-button">
                <a class="header-exit-button" href="#"
                   @click.prevent="onClose">✕</a>
            </slot>
        </div>
    </div>
</template>

<script>
    /*
    * TODO: improve support for more than 10 participants (the names list may break in some cases)
    */
    export default {
        props: {
            myself: {
                type: Object,
                required: true
            },
            other: {
                type: Object,
                required: true
            },
            colors: {
                type: Object,
                required: true
            },
            hideCloseButton: {
                type: Boolean,
                required: false,
                default: false
            },
            closeButtonIconSize: {
                type: String,
                required: false,
                default: "15px"
            },
        },
        computed: {
            hasHeaderSlot: function () {
                return !!this.$slots['header']
            }
        },
        methods:{
            onClose: function(){
                // console.log('header on close')
                this.$emit("onClose")
            },
            onMinimize: function() {
                // console.log('minimize chat')
                this.$emit("onMinimize")
            }
        }
    }
</script>
